import { getBaseAgent, getMpAgent } from '@cibo/core'

export const baseAgent = getBaseAgent()
export const mpAgent = getMpAgent()
